"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOAP_ACTION_SECURITY = exports.SOAP_ACTION_IMAGE_MANAGEMENT = void 0;
var SOAP_ACTION_IMAGE_MANAGEMENT = '/Aperio.Images/Image.asmx';
exports.SOAP_ACTION_IMAGE_MANAGEMENT = SOAP_ACTION_IMAGE_MANAGEMENT;
var SOAP_ACTION_SECURITY = '/Aperio.Security/Security2.asmx';
exports.SOAP_ACTION_SECURITY = SOAP_ACTION_SECURITY;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/core/consts.js
// module id = 41
// module chunks = 0